export function fetchHtml(asset, cb, errcb) {
  fetch(asset)
    .then((response) => {
      return response.text();
    })
    .then((html) => {
      cb(html);
    })
    .catch((err) => {
      if (errcb) {
        errcb(err);
      }
    });
}
